module.exports = __webpack_public_path__ + "static/media/night.97f14c1f.png";